import svgUrl from "ni:svgr;NEVqyJ0whVPIU-pAo5gs4ip1xas2-z7tQWYQ0lDtuaE";
export default svgUrl;
import * as React from "react";
import { memo } from "react";
const FolderSourceLIcon = props => <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" viewBox="0 0 32 32" {...props}><path fill="var(--tbl--colors--icons--misc--folder)" fillRule="evenodd" d="M5 5a3 3 0 0 0-3 3v14a4 4 0 0 0 4 4h20a4 4 0 0 0 4-4V12a4 4 0 0 0-4-4h-9l-1.11-1.664A3 3 0 0 0 13.395 5H5Z" clipRule="evenodd" /><path fill="#fff" fillOpacity={0.3} d="M2 8a3 3 0 0 1 3-3h8.394a3 3 0 0 1 2.497 1.336L17 8H2Z" /></svg>;
const Memo = memo(FolderSourceLIcon);
export { Memo as ReactComponent };
if (import.meta.env.DEV) {
  Memo.displayName = "FolderSourceLIcon";
}